// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file user/gdus_user.proto (package com.americanexpress.dining.user.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user/gdus_user.proto.
 */
export const file_user_gdus_user: GenFile = /*@__PURE__*/
  fileDesc("ChR1c2VyL2dkdXNfdXNlci5wcm90bxIlY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcudXNlci5wcm90byLEAwoIR2R1c1VzZXISEgoFZW1haWwYASABKAlIAIgBARIXCgpmaXJzdF9uYW1lGAIgASgJSAGIAQESFgoJbGFzdF9uYW1lGAMgASgJSAKIAQESGQoMcmVzeV91c2VyX2lkGAQgASgESAOIAQESGwoOdG9ja19wYXRyb25faWQYBSABKARIBIgBARIZCgxwaG9uZV9udW1iZXIYBiABKAlIBYgBARIWCglnZHVzX3V1aWQYByABKAlIBogBARIXCgpjcmVhdGVkX2F0GAggASgJSAeIAQESSAoIbG9ja291dHMYCSADKAsyNi5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy51c2VyLnByb3RvLkdkdXNVc2VyTG9ja291dBIaCg1pc19sb2NrZWRfb3V0GAogASgISAiIAQFCCAoGX2VtYWlsQg0KC19maXJzdF9uYW1lQgwKCl9sYXN0X25hbWVCDwoNX3Jlc3lfdXNlcl9pZEIRCg9fdG9ja19wYXRyb25faWRCDwoNX3Bob25lX251bWJlckIMCgpfZ2R1c191dWlkQg0KC19jcmVhdGVkX2F0QhAKDl9pc19sb2NrZWRfb3V0IrIBCg9HZHVzVXNlckxvY2tvdXQSFQoNaXNfbG9ja2VkX291dBgBIAEoCBIbCg5sb2Nrb3V0X3JlYXNvbhgCIAEoCUgAiAEBEiYKGXVwZGF0ZWRfYnlfdG9ja19wYXRyb25faWQYAyABKARIAYgBARISCgpjcmVhdGVkX2F0GAQgASgJQhEKD19sb2Nrb3V0X3JlYXNvbkIcChpfdXBkYXRlZF9ieV90b2NrX3BhdHJvbl9pZEIpCiVjb20uYW1lcmljYW5leHByZXNzLmRpbmluZy51c2VyLnByb3RvUAFiBnByb3RvMw");

/**
 * @generated from message com.americanexpress.dining.user.proto.GdusUser
 */
export type GdusUser = Message<"com.americanexpress.dining.user.proto.GdusUser"> & {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string first_name = 2;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 3;
   */
  lastName?: string;

  /**
   * cross-system identifier stored in GDUS
   *
   * @generated from field: optional uint64 resy_user_id = 4;
   */
  resyUserId?: bigint;

  /**
   * cross-system identifier stored in GDUS
   *
   * @generated from field: optional uint64 tock_patron_id = 5;
   */
  tockPatronId?: bigint;

  /**
   * @generated from field: optional string phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * @generated from field: optional string gdus_uuid = 7;
   */
  gdusUuid?: string;

  /**
   * @generated from field: optional string created_at = 8;
   */
  createdAt?: string;

  /**
   * @generated from field: repeated com.americanexpress.dining.user.proto.GdusUserLockout lockouts = 9;
   */
  lockouts: GdusUserLockout[];

  /**
   * @generated from field: optional bool is_locked_out = 10;
   */
  isLockedOut?: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.proto.GdusUser.
 * Use `create(GdusUserSchema)` to create a new message.
 */
export const GdusUserSchema: GenMessage<GdusUser> = /*@__PURE__*/
  messageDesc(file_user_gdus_user, 0);

/**
 * @generated from message com.americanexpress.dining.user.proto.GdusUserLockout
 */
export type GdusUserLockout = Message<"com.americanexpress.dining.user.proto.GdusUserLockout"> & {
  /**
   * @generated from field: bool is_locked_out = 1;
   */
  isLockedOut: boolean;

  /**
   * @generated from field: optional string lockout_reason = 2;
   */
  lockoutReason?: string;

  /**
   * @generated from field: optional uint64 updated_by_tock_patron_id = 3;
   */
  updatedByTockPatronId?: bigint;

  /**
   * @generated from field: string created_at = 4;
   */
  createdAt: string;
};

/**
 * Describes the message com.americanexpress.dining.user.proto.GdusUserLockout.
 * Use `create(GdusUserLockoutSchema)` to create a new message.
 */
export const GdusUserLockoutSchema: GenMessage<GdusUserLockout> = /*@__PURE__*/
  messageDesc(file_user_gdus_user, 1);

